import { Divider, Theme, Typography } from "@mui/material";
import MuiMarkdown, { defaultOverrides } from "mui-markdown";
import { COLOR } from "../../utils/colors";
import { VIEW } from "../../utils/breakpoint";
import { ReactNode } from "react";

export default function MarkdownText({
  children
}: {
  children: string | ReactNode
}) {
  return (
    <MuiMarkdown
      options={{
        overrides: {
          ...defaultOverrides,
          hr: {
            component: Divider,
            props: {
              sx: {
                borderColor: COLOR.gray[300],
                marginY: '16px'
              }
            }
          },
          p: {
            component: Typography,
            props: {
              variant: 'body1',
              sx: (theme: Theme) => ({
                color: COLOR.gray[900],
                mb: '4px',
                textAlign: 'justify',
                lineHeight: '1.75',
                fontSize: '16px',
                [theme.breakpoints.down(VIEW.TABLET)]: {
                  mb: '12px',
                  fontSize: '0.875rem',
                  lineHeight: '1.75'

                }
              })
            }
          },
          li: {
            component: Typography,
            props: {
              variant: 'body1',
              as: 'li',
              sx: (theme: Theme) => ({
                color: COLOR.gray[900],
                mb: '8px',
                textAlign: 'justify',
                lineHeight: '1.75',
                fontSize: '16px',
                [theme.breakpoints.down(VIEW.TABLET)]: {
                  mb: '8px',
                  fontSize: '0.875rem',
                  lineHeight: '1.75'
                }
              })
            }
          },
          h6: {
            component: Typography,
            props: {
              variant: 'h6',
              sx: (theme: Theme) => ({
                mb: '2px',
                [theme.breakpoints.down(VIEW.TABLET)]: {
                  mb: '4px',
                }
              })
            }
          }
        }
      }}
    >{children}
    </MuiMarkdown>
  )
}